import { c as _c } from "react/compiler-runtime";
import Carousel from '@/components/modules/Carousel';
import { ESTABLISHMENT_CITY, ESTABLISHMENT_NAME } from '@/constants/config';
import { capitalize } from '@winelidays/wld-tsx-2/utils';
const ExperienceCarousel = t0 => {
    const $ = _c(5);
    const { experience } = t0;
    const imgAltSuffix = experience ? `${capitalize(experience.name)} - ${capitalize(ESTABLISHMENT_NAME)} - ${capitalize(ESTABLISHMENT_CITY)}` : "";
    let t1;
    if ($[0] !== experience?.medias?.media) {
        t1 = experience?.medias?.media || [];
        $[0] = experience?.medias?.media;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const media = t1;
    let t2;
    if ($[2] !== imgAltSuffix || $[3] !== media) {
        t2 = <Carousel media={media} imgAltSuffix={imgAltSuffix} className="rounded-t lg:rounded"/>;
        $[2] = imgAltSuffix;
        $[3] = media;
        $[4] = t2;
    }
    else {
        t2 = $[4];
    }
    return t2;
};
export default ExperienceCarousel;
